import numeral from 'numeral';
/**
 * Will apply the longrunning request-response pattern
 * 202 (w/special headers) -> make request again -> 404 until !404 -> done
 */
export const longrunning = () => {
    const CACHE_HEADER = 'x-growmark-long-running-cache';
    const STARTED_HEADER = 'x-growmark-long-running-started';
    const RETRY_PARAM = 'retry';
    const INTERVAL = 2 * 1000; //in seconds
    const MAXATTEMPTS = 450; // 2seconds + 450 times = 15 min
    return {
        response: (client) => async (response) => {
            const { status, headers, request, config } = response || {};
            if (status != 202) {
                return response;
            }
            const { [CACHE_HEADER]: cache, [STARTED_HEADER]: started } = headers;
            if (!cache || !started) {
                console.warn('[@growmark/axios]: long running endpoint did not meet criteria'); //<-- shouldn't be here if we are long running
                return response;
            }
            const { httpAgent, httpsAgent, url, ...otherStuff } = config || {};
            return await client({
                url, ...otherStuff,
                headers: {
                    ...(config?.headers || {}),
                    ...(request?.headers || {}),
                    [CACHE_HEADER]: cache, [STARTED_HEADER]: started //from response
                }
            });
        },
        error: (client) => async (error) => {
            const { config, response } = error;
            if (!config) {
                throw error;
            }
            const { status, headers } = response || {};
            const { [CACHE_HEADER]: cache, [STARTED_HEADER]: started } = headers || {};
            //only retry when status = 404 and the proper headers exist
            if (!(status === 404 && !!cache && !!started)) {
                throw error;
            }
            await new Promise(resolve => setTimeout(resolve, INTERVAL));
            const { httpAgent, httpsAgent, url, params, ...otherStuff } = config || {};
            const { [RETRY_PARAM]: retry } = params || {};
            const attempt = numeral(retry).value() + 1; //increase attempt
            if (attempt > MAXATTEMPTS) {
                throw error;
            }
            return await client({
                url, ...otherStuff,
                params: {
                    ...(params || {}),
                    [RETRY_PARAM]: `${attempt}`
                }
            });
        }
    };
};
//# sourceMappingURL=longrunning.js.map